import { combineReducers } from '@reduxjs/toolkit';
import { reducer as setCardListReducer } from './services/list';

const setCardsReducers = combineReducers({
  list: setCardListReducer,
});
export default setCardsReducers;
